var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoGray(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Camada_1",
    "data-name": "Camada 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 362.23 103.02",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "-Logo_principal") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Camada_1-2",
    "data-name": "Camada_1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M150.66,41.25c13.17-2.55,17.73,13.16,13.82,22.62-3.12,7.54-11.54,8.05-17.26,4.82a10.6,10.6,0,0,1-3.37-3.09c-.92-1.44-.6-3.71-.6-5.76,0-3.39-.36-9.68.45-12.61C144.6,44,147.08,42,150.66,41.25Zm-7.4,39.19a30.23,30.23,0,0,1,3,1.42A22.62,22.62,0,0,0,149.53,83a24.58,24.58,0,0,0,7.92.8,23.76,23.76,0,0,0,12.94-4.56c21.46-15.85,11.1-50.39-13.16-51.38-8.68-.36-12.49,3.06-14,3.36l0-3.39H126.15l0,75.18,17.17,0Z",
    transform: "translate(0 0)",
    fill: "#bac7d6",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.37,60.07c-1.25,8.31-7.53,11.95-14.75,10.08a14.93,14.93,0,0,1-4.45-2,8.31,8.31,0,0,1-3-3.52c-.39-1.34-.13-10.92-.13-13.08,0-4.48,1.19-7.42,4-9a13.43,13.43,0,0,1,10.81-.61c6.28,2.52,8.5,11.34,7.49,18.15ZM205.09,80.44c2.35.91,3.71,1.9,6.41,2.57,17.13,4.29,32.38-9.18,32.35-27.32,0-7.7-2.89-15.34-8.27-20.25a17.82,17.82,0,0,0-3.4-3.06,24.91,24.91,0,0,0-20.84-3.73c-3.67,1-4.33,1.9-6.23,2.58l0-3.34L188,27.81l0,75.13,17.16-.06V80.44Z",
    transform: "translate(0 0)",
    fill: "#bac7d6",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323.24,81.33c.14-8.89,0-17.89,0-26.79,0-4.71-.45-8.07,2.52-10.83,2.45-2.28,5.06-4.24,8.64-4.73a9.11,9.11,0,0,1,9.11,4c1.79,3.09,1.93,7.42,1.93,11.55,0,8.86-.09,17.77,0,26.64l16.78.15V55.69c0-8.24-.81-15-4.56-21.07-2.93-4.75-7.73-9.68-15.78-9.89a25.63,25.63,0,0,0-18.44,7.06V2l-17.19,0,0,79.41Z",
    transform: "translate(0 0)",
    fill: "#bac7d6",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.2,56.66c.42,7.07-.29,10.29-5.69,12.64-4.64,2-10.48,2.42-14.5-.51-2.71-2-4.63-7.44,4.82-9.38,2.55-.53,5.22-.92,7.86-1.38,2.45-.42,5.17-1.05,7.51-1.37Zm-29.2-15c6.65-1.47,17.71-5,23.84-1.56a6.84,6.84,0,0,1,3.77,5.67c-12.5,2.09-39.59,2.5-37.22,21.12,1,8.17,6.64,13.26,14.75,14.44,10.15,1.48,16-1.81,24.16-4.2l.05,4.46,15.29.07c.07-9.09.23-18.32-.07-27.39-.31-9.23-.69-16.08-5.71-21.59C286.33,24.45,272,25,260.93,26.85c-6.26,1-6.58,1.73-10.88,2.77L255,41.69Z",
    transform: "translate(0 0)",
    fill: "#bac7d6",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27,38.84c8.34-1.93,14.92,5.1,15.87,12C44.12,59.57,39,66.69,32.25,68.1c-12,2.53-20.85-12.31-13.55-23.46A12.92,12.92,0,0,1,27,38.84ZM.1,55.46C.83,64.23,4,69.31,9.67,74.84c6.09,5.9,13.4,7,21.92,6.94A26.79,26.79,0,0,0,43.39,79c18.83-9.49,20.78-34.89,6-47.13-6.55-5.41-11-6.9-22-6.79A28.1,28.1,0,0,0,.1,55.46Z",
    transform: "translate(0 0)",
    fill: "#bac7d6",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.35,55a15.58,15.58,0,0,1,3-11c3.29-4.37,9.23-7,15.06-4.64a13,13,0,0,1,2.3,1.16,11.67,11.67,0,0,1,2,1.7c9.06,8.68,3.94,24.93-7.49,26.06C84,69.11,78,62.35,77.35,55Zm42.93.92a29.16,29.16,0,0,0-1.65-12.57,29.46,29.46,0,0,0-9.36-12.55A26.23,26.23,0,0,0,105,28a27.42,27.42,0,0,0-11.34-2.85c-9.65-.3-16.78,1.41-22.36,6.59a29.26,29.26,0,0,0-6.58,8,26.89,26.89,0,0,0-3.28,11.07c-1.38,16.5,10.54,30.38,26.67,31,4.5.17,9.21,0,13.18-1.37A28.35,28.35,0,0,0,120.28,55.92Z",
    transform: "translate(0 0)",
    fill: "#bac7d6",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.24,26.14c0-9.62-9-17.41-20.08-17.41V12c9,0,16.34,6.35,16.34,14.17Z",
    transform: "translate(0 0)",
    fill: "#bac7d6",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.31,26.14C70.31,11.7,56.81,0,40.16,0V4.24c14,0,25.26,9.81,25.26,21.9Z",
    transform: "translate(0 0)",
    fill: "#bac7d6",
    fillRule: "evenodd"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoGray);
export default __webpack_public_path__ + "static/media/logo_gray.1729fac492e39abff705e60f6b571aea.svg";
export { ForwardRef as ReactComponent };